import * as React from 'react';
import Icon from 'src/components/Icon';

const InitialMessage = () => (
  <div className="flex-1 has-background-white p-5">
    <div className="flex items-center justify-center w-full h-full border border-dark-gray-body min-h-104">
      <div className="f2 font-semibold text-center w-6/12">
        <Icon name="pencil" className="w-8 h-8 mb-6" />
        <p className="mb-6">Klik på et tema for at redigere billede og stamdata.</p>
        <p>God fornøjelse</p>
      </div>
    </div>
  </div>
);

export default InitialMessage;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/ThemeSectionEditor/components/InitialMessage.tsx